var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueEditor',{attrs:{"id":_vm.editorId,"value":_vm.content,"editor-toolbar":_vm.customToolbar,"editor-options":_vm.editorOptions,"use-custom-image-handler":""},on:{"image-added":_vm.handleImageAdded,"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }